import { render, staticRenderFns } from "./UserIndex.vue?vue&type=template&id=1f028e47&scoped=true&"
import script from "./UserIndex.vue?vue&type=script&lang=js&"
export * from "./UserIndex.vue?vue&type=script&lang=js&"
import style0 from "./UserIndex.vue?vue&type=style&index=0&id=1f028e47&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f028e47",
  null
  
)

export default component.exports